import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IBannerLeftContent {
	image?: IImage;
	heading?: string;
	link?: ILink;
}

export interface IBannerRightContent {
	image?: IImage;
	heading?: string;
	link?: ILink;
}

export interface IMainHeroBannerProps extends IBaseElementProps {
	children?: any;
	bannerLeftSide?: IBannerLeftContent;
	bannerRightSide?: IBannerRightContent;
}

/**
 * MainHeroBanner
 * @block
 * @requiresHooks
 * @icon image-flip-horizontal
 */
const MainHeroBanner: React.FC<IMainHeroBannerProps> = ({
	children,
	className,
	classNames = [],
	bannerLeftSide,
	bannerRightSide,
}) => (
	<div className={className || cn('main-hero-banner', ...classNames)}>
		<div className="container-fluid">
			<div className="row">
				<div className="col-md-6 p-0">
					{bannerLeftSide && (
						<div className="main-hero-banner__left">
							{bannerLeftSide.image && (
								<Image
									className="main-hero-banner__image img-fluid"
									{...bannerLeftSide.image}
								/>
							)}
							<div className="main-hero-banner__left-overlay-color"></div>
							<div className="main-hero-banner__left-overlay">
								{bannerLeftSide.heading && (
									<p className="main-hero-banner__heading">
										{bannerLeftSide.heading}
									</p>
								)}
								{bannerLeftSide.link && (
									<Button
										{...bannerLeftSide.link}
										className="main-hero-banner__button btn btn-lg btn-secondary"
									/>
								)}
							</div>
						</div>
					)}
				</div>
				<div className="col-md-6 p-0">
					{bannerRightSide && (
						<div className="main-hero-banner__right">
							{bannerRightSide.image && (
								<Image
									className="main-hero-banner__image img-fluid"
									{...bannerRightSide.image}
								/>
							)}
							<div className="main-hero-banner__right-overlay-color"></div>
							<div className="main-hero-banner__right-overlay">
								{bannerLeftSide.heading && (
									<p className="main-hero-banner__heading">
										{bannerRightSide.heading}
									</p>
								)}
								{bannerLeftSide.link && (
									<Button
										{...bannerRightSide.link}
										className="main-hero-banner__button btn btn-lg btn-secondary"
									/>
								)}
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	</div>
);

export default MainHeroBanner;
